import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PrivacyPage() {
  const updated = "January 2026";
  return (
    <main className="max-w-3xl mx-auto px-6 py-12 prose prose-slate" data-testid="privacy-page">
      <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-[color:var(--brand-primary)] mb-6 no-underline">
        <ArrowLeft className="w-4 h-4"/> Back to home
      </Link>
      <p className="font-overline text-xs" style={{ color: "var(--brand-secondary)" }}>Legal</p>
      <h1 className="font-heading text-4xl md:text-5xl tracking-tight mb-2" style={{ color: "var(--brand-primary)" }}>Privacy Policy</h1>
      <p className="text-slate-500 text-sm">Last updated: {updated}</p>

      <h2>1. Introduction</h2>
      <p>This Privacy Policy describes how our sports record book platform ("we", "us", "our") collects, uses, and safeguards information when you visit or interact with this site. By using the site you agree to the practices described here.</p>

      <h2>2. Information We Collect</h2>
      <p>We aim to collect the minimum data needed to operate the platform:</p>
      <ul>
        <li><strong>Public record data.</strong> Athlete names, school names, years, and statistical results — as submitted by coaches, athletic directors, and administrators.</li>
        <li><strong>Administrator accounts.</strong> Names, email addresses, and hashed passwords for authorized users (Super Admin, Athletic Director, Coach).</li>
        <li><strong>Basic technical data.</strong> Cookies used for keeping you signed in, and standard server logs (IP address, browser type) used for security and performance monitoring.</li>
      </ul>

      <h2>3. How We Use Information</h2>
      <ul>
        <li>To display and organize the historical sports records for public browsing.</li>
        <li>To let authenticated administrators submit, approve, edit, or remove records.</li>
        <li>To protect the site against abuse (rate limiting, brute-force lockouts).</li>
      </ul>

      <h2>4. Athlete & Minor Considerations</h2>
      <p>Records may include the names of student athletes, some of whom are minors. We only publish records that have been approved by the school's athletic staff. If you are a parent, guardian, or the athlete themselves and wish to have a specific record corrected or removed, please contact the site administrator using the contact address in the footer of this site.</p>

      <h2>5. Cookies</h2>
      <p>We use a single essential authentication cookie (<code>access_token</code>) for administrators. We do not use third-party advertising cookies or cross-site trackers.</p>

      <h2>6. Data Sharing</h2>
      <p>We do not sell your personal information. Approved records are, by design, publicly visible on the site. Administrator account data is never shared externally.</p>

      <h2>7. Data Retention & Security</h2>
      <p>Records are retained indefinitely as part of the historical archive. Passwords are stored using industry-standard hashing. We recommend administrators use strong, unique passwords and treat their credentials as confidential.</p>

      <h2>8. Your Rights</h2>
      <p>Depending on your location, you may have rights to access, correct, or request removal of information about you. To make such a request, contact the site administrator at the email address shown in the footer.</p>

      <h2>9. Children's Privacy</h2>
      <p>This site is designed for public visibility of school athletic records. We do not knowingly solicit personal information from children beyond what is included in approved public records. Parents or guardians who believe unauthorized personal information has been posted may request correction or removal at any time.</p>

      <h2>10. Changes to This Policy</h2>
      <p>We may update this Privacy Policy from time to time. Updates will be posted on this page with a revised "Last updated" date.</p>

      <h2>11. Contact</h2>
      <p>Questions or requests may be sent to the contact email shown in the site footer.</p>
    </main>
  );
}
